export var RequestType;
(function (RequestType) {
    RequestType["AWARDS"] = "AWARDS";
    RequestType["BEST_DISH_IMAGE"] = "BEST_DISH_IMAGE";
    RequestType["BEST_DISH_IMAGE_DESCRIPTION"] = "BEST_DISH_IMAGE_DESCRIPTION";
    RequestType["COMMENTARY"] = "COMMENTARY";
    RequestType["EMAIL_BODY"] = "EMAIL_BODY";
    RequestType["EMAIL_SUBJECT"] = "EMAIL_SUBJECT";
    RequestType["INTERESTING_THEMES"] = "INTERESTING_THEMES";
    RequestType["MEME_IMAGE"] = "MEME_IMAGE";
    RequestType["MEME_IMAGE_DESCRIPTION"] = "MEME_IMAGE_DESCRIPTION";
    RequestType["MEME_TEMPLATES"] = "MEME_TEMPLATES";
    RequestType["NEWSPAPER_IMAGE"] = "NEWSPAPER_IMAGE";
    RequestType["NEWSPAPER_SECTIONS"] = "NEWSPAPER_SECTIONS";
    RequestType["NEWSPAPER_STORY"] = "NEWSPAPER_STORY";
    RequestType["OBSERVATION_NOTES"] = "OBSERVATION_NOTES";
    RequestType["OPEN_ENDED_PROMPTS"] = "OPEN_ENDED_PROMPTS";
    RequestType["OPINION_ANSWERS"] = "OPINION_ANSWERS";
    RequestType["OPINION_QUESTIONS"] = "OPINION_QUESTIONS";
    RequestType["QUESTIONS"] = "QUESTIONS";
    RequestType["RANDOM_PART_OF_SPEECH"] = "RANDOM_PART_OF_SPEECH";
    RequestType["SELF_REFLECTIONS"] = "SELF_REFLECTIONS";
    RequestType["TREATMENTS_HEAL"] = "TREATMENTS_HEAL";
    RequestType["TREATMENTS_HURT"] = "TREATMENTS_HURT";
    RequestType["TROPHY_IMAGE"] = "TROPHY_IMAGE";
    RequestType["TROPHY_IMAGE_DESCRIPTION"] = "TROPHY_IMAGE_DESCRIPTION";
    RequestType["BURROW_NAMES"] = "BURROW_NAMES";
    RequestType["GAME_COVER_IMAGE"] = "GAME_COVER_IMAGE";
    RequestType["GAME_BACKGROUND_IMAGE"] = "GAME_BACKGROUND_IMAGE";
    RequestType["FARM_GOOD_CARDS"] = "FARM_GOOD_CARDS";
    RequestType["FARM_BAD_CARDS"] = "FARM_BAD_CARDS";
    RequestType["FARM_CRAP_CARDS"] = "FARM_CRAP_CARDS";
    RequestType["CASE_THEME_CANDIDATES"] = "CASE_THEME_CANDIDATES";
    RequestType["CASE_FILE_PROMPTS"] = "CASE_FILE_PROMPTS";
    RequestType["END_OF_DAY_MEMO"] = "END_OF_DAY_MEMO";
    RequestType["PROMPT_ANSWERS"] = "PROMPT_ANSWERS";
    RequestType["WILD_ANIMAL_CANDIDATES"] = "WILD_ANIMAL_CANDIDATES";
    RequestType["WILD_SIGHTING_SUGGESTION_CHECK"] = "WILD_SIGHTING_SUGGESTION_CHECK";
    RequestType["WILD_THING_IMAGE"] = "WILD_THING_IMAGE";
    RequestType["SKETCH_SUBJECTS"] = "SKETCH_SUBJECTS";
    RequestType["ABSURD_CRIMES"] = "ABSURD_CRIMES";
    RequestType["CRIME_DECOY"] = "CRIME_DECOY";
    RequestType["EXPEDITION_LOG"] = "EXPEDITION_LOG";
})(RequestType || (RequestType = {}));
export var EmailType;
(function (EmailType) {
    EmailType["NEW_LEAD_SUPER60"] = "NEW_LEAD_SUPER60";
    EmailType["NEW_LEAD_VIP"] = "NEW_LEAD_VIP";
    EmailType["NEW_LEAD_BFF"] = "NEW_LEAD_BFF";
    EmailType["NEW_LEAD_GIFT"] = "NEW_LEAD_GIFT";
    EmailType["NEW_LEAD_NYNG"] = "NEW_LEAD_NYNG";
    EmailType["NEW_LEAD_MM"] = "NEW_LEAD_MM";
    EmailType["NEW_LEAD_KINDRED"] = "NEW_LEAD_KINDRED";
    EmailType["OTP_REQUEST"] = "OTP_REQUEST";
})(EmailType || (EmailType = {}));
export var ServiceType;
(function (ServiceType) {
    ServiceType["TEXT"] = "TEXT";
    ServiceType["IMAGE"] = "IMAGE";
})(ServiceType || (ServiceType = {}));
export const PROMPT_HEADERS = {
    context: 'CONTEXT',
    task: 'TASK',
    requirements: 'REQUIREMENTS',
    constraints: 'CONSTRAINTS',
    examples: 'EXAMPLES',
    style: 'STYLE',
};
export const TEXT_FORMATTING_STYLES = {
    STANDARD: 'Use only standard punctuation and letter casing.',
    OPEN_ENDED: 'Use standard letter casing. The output must end with an incomplete phrase followed by an ellipsis that invites completion by the player.',
    TITLE: 'The output should be in title case with no ending punctuation.',
};
//# sourceMappingURL=google.js.map